import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { AuthService } from '@core';
import { CommonSharedService } from '@shared/services/common-shared.service';
import { HelpersService } from '@shared/services/helpers.service';
import { UsersService } from 'app/home/users/services/users.service';
import { environment } from 'environments/environment.development';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ReplaySubject, takeUntil } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-twofa-modal',
  standalone: true,
  imports: [MatIconModule, MatSlideToggleModule, FormsModule, MatButtonModule, MatDividerModule],
  templateUrl: './twofa-modal.component.html',
  styleUrl: './twofa-modal.component.scss',
  providers: [BsModalService],
})
export class TwofaModalComponent {
  @ViewChild('template', { static: true }) template: any;
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);
  modalRef?: BsModalRef;
  qrName: string = ''
  enable2Fa:boolean=false
  isModalOpen: boolean = false; 
  isLoading:boolean=false
  constructor(private modalService: BsModalService, private commonSharedService: CommonSharedService, private userService: UsersService,private helperService:HelpersService, private router: Router,private authService:AuthService) {
    commonSharedService.get2FAModal()
    .pipe(takeUntil(this.destroy)).subscribe((res) => {
      console.log(res,"trigger");
      if (res) {
        this.verify2FAEnabled()
        this.getQr()
      }
    })
  }
  showModal() {
    if (this.isModalOpen) {
      return;
    }

    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-dialog-centered modal-sm',
    });
    this.modalRef.onHide?.subscribe((res) => (this.isModalOpen = false));
    this.isModalOpen = true;
  }

  close() {
    if (this.modalRef) {
      this.modalRef.hide();
    } else {
      console.log('Modal reference is null, cannot close');
    }
  }

  getQr() {
    if (localStorage.getItem('2faQr')) {
      this.qrName = localStorage.getItem('2faQr') ?? '';
      this.showModal();
    } else {
      this.generateQR();
    }
  }

  generateQR() {
    this.userService
      .generate2FAQr()
      .pipe(takeUntil(this.destroy))
      .subscribe((res: any) => {
        this.qrName = res.fileName;
        localStorage.setItem('2faQr', this.qrName);
        this.showModal();
      });
  }
  verify2FAEnabled() {
    this.userService
      .verify2FAEnabled()
      .pipe(takeUntil(this.destroy))
      .subscribe((res: any) => {
        this.enable2Fa = res;
      });
  }

  get getUrl() {
    return environment.baseUrl + 'api/files/' + encodeURIComponent(this.qrName);
  }

  ngOnDestroy(): void {
    this.commonSharedService.setF2FAModal(false);
    this.destroy.next(null);
  }

  toggle2FA(){

    this.isLoading=true
    this.userService.enable2FA(this.enable2Fa).pipe(takeUntil(this.destroy)).subscribe((res: any)=>{
      if (this.enable2Fa) {
      this.helperService.showSuccessToast('Two-Factor Authentication (2FA) enabled successfully. Please re-login to complete the setup') 
        setTimeout(() => {
          this.authService.logout().subscribe(res=>{});
      
        }, 3000);
       }else{
        this.isLoading=false
        this.helperService.showUpdateSuccessToast();
      }
    })
  }
}
